import $ from "jquery";
//import Isotope from "isotope-layout"; 
//import 'isotope-packery';
// npm install isotope-layout
// npm install isotope-packery
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';

$(function () {
    $(".bl-portfoliolist").each(function () {
        initBlock($(this));
    });
});

function initBlock($bl) {
    /*
    //Init isotope
    const $guttersizer = $bl.find(".guttersizer");
    const $columnsizer = $bl.find(".columnsizer");

    const iso = new Isotope($bl.find(".ctritems").get(0), {
        layoutMode: 'packery',
        itemSelector: ".item",
        percentPosition: true,
        packery: {
            gutter: $guttersizer.get(0),
            columnWidth: $columnsizer.get(0)
        }
    });

    $(window).on("load", function() {
        iso.layout();
    });


    //Init filter
    const $filterbuttons = $bl.find(".ctrfilterbuttons");
    $filterbuttons.on("click", ".filterbutton", function() {
        const $filterbutton = $(this);
        const requestedFilter = $filterbutton.data("filter");

        highlightFilterButton(requestedFilter);
        filterIsotope(requestedFilter);
    });

    function highlightFilterButton(requestedFilter) {
        $filterbuttons.find(".filterbutton").removeClass("active");
        $filterbuttons.find("[data-filter='"+requestedFilter+"']").addClass("active");
    }

    function filterIsotope(requestedFilter) {
        if(requestedFilter == "*") {
            clearFilterIsotope();
            return;
        }

        iso.arrange({
            filter: ".filter-"+requestedFilter
        });
    }

    function clearFilterIsotope() {
        iso.arrange({
            filter: ""
        });
    }
    */

    initFilter($bl);
    initPhotoSwipe($bl);
}

function initFilter($bl) {
    const $ctritems = $bl.find(".ctritems");

    const $ctrfilterbuttons = $bl.find(".ctrfilterbuttons");
    $ctrfilterbuttons.on("click", "a", function() {
        const $filterbutton = $(this);
        $filterbutton.addClass("active").siblings().removeClass("active");
        const category = $filterbutton.data("category");
        $ctritems.fadeOut(200, function() {
            if(category == "*") {
                $ctritems.find(".item").show();
            } else {
                $ctritems.find(".item").hide();
                $ctritems.find(".item[data-category='"+category+"']").show();
            }
            $ctritems.fadeIn(200);
        });
    });
}

function initPhotoSwipe($bl) {
    $bl.on("click", ".item", function () {
        const $item = $(this);
        const $imageinfos = $item.find(".imageinfo");
        const imagedata = $imageinfos.map(function () {
            const $imageinfo = $(this);
            return {
                src: $imageinfo.data("url"),
                width: $imageinfo.data("width"),
                height: $imageinfo.data("height")
            };
        }).get(); //.get(): Convert jQuery-Array-Object to basic array

        const options = {
            dataSource: imagedata,
            showHideAnimationType: 'fade', //'zoom' / 'fade'
            pswpModule: PhotoSwipe,
            paddingFn: (viewportSize) => {
                return {
                    top: 15, bottom: 15, left: 15, right: 15
                };
            },
            bgOpacity: 0.9
        };

        console.log(options);

        const pswp = new PhotoSwipe(options);
        pswp.init();
    });
}
